import { render } from "./PageSection.vue?vue&type=template&id=5acc1a6f&scoped=true"
import script from "./PageSection.vue?vue&type=script&lang=js"
export * from "./PageSection.vue?vue&type=script&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=5acc1a6f&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acc1a6f"]])

export default __exports__